import React from "react";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import useInViewOnce from "../../hooks/useInViewOnce";
import { useTranslation } from "react-i18next";

function Techstack() {
  const { t } = useTranslation();
  const { ref, inView, hasEntered } = useInViewOnce({ once: false });

  const fallbackBeliefs = [
    "We believe equity is achieved by valuing all voices, fostering inclusion, and empowering individuals to contribute to community well-being.",
    "We create supportive spaces for youth and adults to belong, connect personal growth with social change, and inspire collaboration to tackle shared challenges.",
    "We are dedicated to fairness and equality, working to dismantle systemic barriers and ensure everyone has the opportunity to thrive.",
    "We believe meaningful change occurs when we create equitable opportunities for individuals while also addressing the systemic challenges that impact our world.",
    "We value collaboration as a skill that empowers individuals to work effectively across cultures, navigate team dynamics, and foster mutual learning and growth.",
    "We believe technology should be human-centered—built with empathy and transparency—so innovation serves people and strengthens communities.",
  ];

  const translatedBeliefs = t("aboutWho.beliefs.items", { returnObjects: true });
  const beliefs = Array.isArray(translatedBeliefs) && translatedBeliefs.length ? translatedBeliefs : fallbackBeliefs;

  return (
    <Row
      ref={ref}
      className={`about-beliefs${hasEntered ? " about-seen" : ""}${inView ? " about-inview" : ""}`}
      style={{ justifyContent: "center" }}
    >
      {beliefs.map((belief, index) => (
        <Col key={`${index}-${belief.slice(0, 24)}`} xs={12} md={6} lg={4} className="about-belief-col">
          <Card
            className="policy-card about-belief-card about-anim-card"
            style={{ animationDelay: `${index * 80}ms` }}
          >
            <Card.Body>
              <blockquote className="blockquote mb-0">
                <p className="about-text about-belief-text">{belief}</p>
              </blockquote>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
